import React from 'react';
export function UpsellTransition() {
  return <section className="w-full bg-black py-20 px-4 text-white border-t border-gray-800" data-id="element-304">
      <div className="max-w-4xl mx-auto text-center" data-id="element-305">
        <span className="bg-yellow-500/20 text-yellow-400 border border-yellow-500/50 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-306">
          Esperá — Hay personas que ahorran el doble con esta versión
        </span>
        <h2 className="text-3xl md:text-5xl font-black text-white mt-8 mb-6 leading-tight" data-id="element-307">
          ¿Querés Resultados Más Rápidos y También Ganar Dinero con Esto?
        </h2>
        <div className="prose prose-lg prose-invert max-w-none text-gray-300 font-medium" data-id="element-308">
          <p data-id="element-309">
            Miles de personas ya están usando Electricista en Casa para resolver
            sus averías. Pero hay un grupo que además está cobrando por hacerlo
            para otros.
          </p>
          <p className="text-2xl font-bold text-white mt-6" data-id="element-310">
            ¿La diferencia? Eligieron la Edición Profesional Completa.
          </p>
        </div>
      </div>
    </section>;
}